export const TextStyles: any = {};

TextStyles.smallTextBlack = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Coiny',
  fontSize: '24px',
  fontWeight: 'bold',
  fill: '#251187',
  align: 'center',
  wordWrap: true,
});

TextStyles.smallTextWhite = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Coiny',
  fontSize: '24px',
  fontWeight: 'bold',
  fill: '#ffffff',
  align: 'center',
  wordWrap: true,
});

TextStyles.winPopupLabel = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Chewy',
  fontSize: '24px',
  fontWeight: 'bold',
  fill: '#F7EDCA',
  stroke: '#000000',
  strokeThickness: 2,
  align: 'right',
});

TextStyles.winPopupText = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Chewy',
  fontSize: '28px',
  fontWeight: 'bold',
  fill: '#F7EDCA',
  // stroke: '#000000',
  // strokeThickness: 2,
  align: 'right',
});

TextStyles.winPopupTextCoins = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Chewy',
  fontSize: '28px',
  fontWeight: 'bold',
  fill: '#ffe600',
  // stroke: '#000000',
  // strokeThickness: 2,
  align: 'right',
});

TextStyles.winPopupTextTotal = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Chewy',
  fontSize: '44px',
  fontWeight: 'bold',
  fill: '#ffe600',
  // stroke: '#000000',
  // strokeThickness: 2,
  align: 'right',
});

TextStyles.smallParagraphText = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Chewy',
  fontSize: '24px',
  fontWeight: 'bold',
  fill: '#251187',
  align: 'center',
});

TextStyles.verySmallTextBlack = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Chewy',
  fontSize: '18px',
  fontWeight: 'bold',
  fill: '#251187',
  align: 'right',
  wordWrap: true,
});

TextStyles.uiText = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Coiny',
  fontSize: '32px',
  fill: '#251187',
  align: 'center',
});

TextStyles.uiTextHalloween = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Coiny',
  fontSize: '32px',
  fill: '#fff84e',
  align: 'center',
});

TextStyles.uiTextPink = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Coiny',
  fontSize: '32px',
  fill: '#DF23A3',
  align: 'center',
});

TextStyles.uiTextWhite = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Coiny',
  fontSize: '32px',
  fill: '#ffffff',
  align: 'center',
});

TextStyles.buttonLabel = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Coiny',
  fontSize: '72px',
  fill: '#F7EDCA',
  // stroke: '#000000',
  // strokeThickness: 3,
  align: 'center',
});

TextStyles.counterText = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Coiny',
  fontSize: '42px',
  fill: '#F7EDCA',
  // stroke: '#000000',
  // strokeThickness: 3,
  align: 'center',
  dropShadow: true,
  dropShadowAlpha: 0.5,
  dropShadowAngle: 1.5707963268,
  dropShadowBlur: 1,
  dropShadowDistance: 3,
});

TextStyles.nameText = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Coiny',
  fontSize: '32px',
  fill: '#F7EDCA',
  // stroke: '#000000',
  // strokeThickness: 2,
  align: 'center',
  dropShadow: true,
  dropShadowAlpha: 0.5,
  dropShadowAngle: 1.5707963268,
  dropShadowBlur: 1,
  dropShadowDistance: 3,
});

TextStyles.chapterWinTextLeft = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Coiny',
  fontSize: '84px',
  fill: ['#fef401', '#ff9101'],
  stroke: '#000000',
  strokeThickness: 3,
  align: 'right',
  dropShadow: true,
  dropShadowAlpha: 0.5,
  dropShadowAngle: 1.5707963268,
  dropShadowBlur: 1,
  dropShadowDistance: 3,
});

TextStyles.chapterWinTextRight = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Coiny',
  fontSize: '84px',
  fill: ['#fef401', '#ff9101'],
  stroke: '#000000',
  strokeThickness: 3,
  align: 'left',
  dropShadow: true,
  dropShadowAlpha: 0.5,
  dropShadowAngle: 1.5707963268,
  dropShadowBlur: 1,
  dropShadowDistance: 3,
});

TextStyles.messageText = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Coiny',
  fontSize: '56px',
  fill: ['#fef401', '#ff9101'],
  stroke: '#000000',
  strokeThickness: 10,
  align: 'left',
  dropShadow: true,
  dropShadowAlpha: 0.5,
  dropShadowAngle: 1.5707963268,
  dropShadowBlur: 1,
  dropShadowDistance: 3,
  letterSpacing: 1,
});

TextStyles.smallMessageText = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Coiny',
  fontSize: '28px',
  fill: ['#fef401', '#ff9101'],
  stroke: '#000000',
  strokeThickness: 3,
  align: 'center',
  dropShadow: true,
  dropShadowAlpha: 0.5,
  dropShadowAngle: 1.5707963268,
  dropShadowBlur: 1,
  dropShadowDistance: 3,
  letterSpacing: 1,
});

TextStyles.scoreText = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Coiny',
  fontSize: '72px',
  fill: ['#8cdb49', '#88ff01'],
  stroke: '#000000',
  strokeThickness: 10,
  align: 'center',
  dropShadow: true,
  dropShadowAlpha: 0.5,
  dropShadowAngle: 1.5707963268,
  dropShadowBlur: 1,
  dropShadowDistance: 3,
  letterSpacing: 1,
});

TextStyles.scoreTextSmall = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Coiny',
  fontSize: '32px',
  fill: ['#8cdb49', '#88ff01'],
  stroke: '#000000',
  strokeThickness: 10,
  align: 'center',
  dropShadow: true,
  dropShadowAlpha: 0.5,
  dropShadowAngle: 1.5707963268,
  dropShadowBlur: 1,
  dropShadowDistance: 3,
  letterSpacing: 1,
});

TextStyles.messageTextRed = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Coiny',
  fontSize: '56px',
  fill: ['#ec3f3f', '#db1b1b'],
  stroke: '#000000',
  strokeThickness: 10,
  align: 'left',
  dropShadow: true,
  dropShadowAlpha: 0.5,
  dropShadowAngle: 1.5707963268,
  dropShadowBlur: 1,
  dropShadowDistance: 3,
  letterSpacing: 1,
});

TextStyles.comboText = new PIXI.TextStyle({
  lineJoin: 'round',
  fontFamily: 'Coiny',
  fontSize: '56px',
  fill: ['#fef401', '#ff9101'],
  stroke: '#000000',
  strokeThickness: 10,
  align: 'center',
  dropShadow: true,
  dropShadowAlpha: 0.5,
  dropShadowAngle: 1.5707963268,
  dropShadowBlur: 1,
  dropShadowDistance: 3,
  letterSpacing: 1,
});